module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.service) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "is-half column"
  }, [_c('service', {
    attrs: {
      "service": _vm.service
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "is-half column"
  }, [_c('occurrences-simple', {
    attrs: {
      "service": _vm.service
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 99) ? _c('occurrences-simple', {
    attrs: {
      "service": _vm.service,
      "internal": true
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), ((parseInt(_vm.$store.state.config.user.level) < 99) && (parseInt(_vm.service.dispute_v2) !== 0)) ? _c('dispute', {
    attrs: {
      "service": _vm.service
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 99) ? _c('financial', {
    attrs: {
      "service": _vm.service
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 99) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-info",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_vm._v("History Financial\n            "), _c('button', {
    staticClass: "button is-success is-small",
    on: {
      "click": function($event) {
        return _vm.loadHistoryFinancial()
      }
    }
  }, [_vm._v("Load history")])]), _vm._v(" "), (_vm.load_history_financial === 1) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('historyFinancial', {
    attrs: {
      "service": _vm.service
    }
  })], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 99) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel-success"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-success",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_vm._v("History Extend\n            "), _c('button', {
    staticClass: "button is-info is-small",
    on: {
      "click": function($event) {
        return _vm.loadHistoryExtend()
      }
    }
  }, [_vm._v("Load history")])]), _vm._v(" "), (_vm.load_history_extend === 1) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('historyExtend', {
    attrs: {
      "service": _vm.service
    }
  })], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 99) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel-success"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-success",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_vm._v("History Clara\n            "), _c('button', {
    staticClass: "button is-info is-small",
    on: {
      "click": function($event) {
        return _vm.loadHistoryClara()
      }
    }
  }, [_vm._v("Load history")])]), _vm._v(" "), (_vm.load_history_clara === 1) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('historyClara', {
    attrs: {
      "service": _vm.service
    }
  })], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 99) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel-success"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-success",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_vm._v("History Jeeves\n            "), _c('button', {
    staticClass: "button is-info is-small",
    on: {
      "click": function($event) {
        return _vm.loadHistoryJeeves()
      }
    }
  }, [_vm._v("Load history")])]), _vm._v(" "), (_vm.load_history_jeeves === 1) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('historyJeeves', {
    attrs: {
      "service": _vm.service
    }
  })], 1) : _vm._e()])])]) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5815692a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/services/Service.vue
// module id = 1135
// module chunks = 39